import { format } from "date-fns";
import { TFunction } from "i18next";

import { useGetAllDirectionsForSelectLazy } from "~/entity/Directions";
import { FilterField } from "~/features/filter";
import type { FilterFieldOptionsHookResult } from "~/features/filter";

const yesNoOptions = (t: TFunction) => [
  { value: "true", label: t("ui.filterPositive") },
  { value: "false", label: t("ui.filterNegative") },
];

export const useDirectionOptions = (): FilterFieldOptionsHookResult => {
  const { directions, searchText, isLoading } =
    useGetAllDirectionsForSelectLazy({
      ActualOn: format(new Date(), "yyyy-MM-dd"),
    });

  return {
    options: directions
      .filter(({ value }) => value !== undefined && value !== null)
      .map(({ value, label }) => ({ value: String(value), label })),
    loading: isLoading,
    searchOptions: searchText,
  };
};

export const positionsDirectoryFilterFields = (t: TFunction): FilterField[] => [
  {
    name: "event",
    type: "datePicker",
    label: t("cep.actual_date_on"),
    disableFutureDates: true,
  },
  {
    name: "name",
    type: "input",
    label: t("positionDirectory.titlePosition"),
  },
  {
    name: "id",
    type: "input",
    label: t("positionDirectory.id"),
  },
  {
    name: "code",
    type: "input",
    label: t("positionDirectory.positionCode"),
  },
  {
    name: "status",
    type: "select",
    label: t("positionDirectory.status"),
    options: [
      { value: "active", label: t("positionDirectory.active") },
      { value: "inactive", label: t("positionDirectory.inactive") },
    ],
  },
  {
    name: "DirectionId",
    type: "select",
    label: t("positionDirectory.belongingDirectionID"),
    optionsHook: useDirectionOptions,
    newRow: true,
  },
  {
    name: "showInZd",
    type: "select",
    label: t("positionDirectory.showInZd"),
    options: yesNoOptions(t),
  },
  {
    name: "jobDescriptionIsRequired",
    type: "select",
    label: t("positionDirectory.jobDescriptionIsRequired"),
    options: yesNoOptions(t),
  },
  {
    name: "creationFrom",
    nameTo: "creationTo",
    type: "dateRange",
    label: t("positionDirectory.createdAt"),
    placeholder: t("positionDirectory.data_begin"),
    placeholderTo: t("positionDirectory.data_end"),
    span: 2,
    disableFutureDates: true,
  },
  {
    name: "lastEditFrom",
    nameTo: "lastEditTo",
    type: "dateRange",
    label: t("positionDirectory.updatedAt"),
    placeholder: t("positionDirectory.data_begin"),
    placeholderTo: t("positionDirectory.data_end"),
    span: 2,
    disableFutureDates: true,
  },
];
